import React from "react";
import { FaBuilding, FaCalendarAlt, FaCouch } from "react-icons/fa";
import { MdApartment, MdFormatSize } from "react-icons/md";


const AboutProjectSection = ({project}) => {


  const aboutDetails = [
    { label: "Project Size", value: project?.projectDetails?.projectSize || "N/A", icon: <MdFormatSize /> },
    { label: "Launch Date", value: project?.projectDetails?.launchDate || "N/A", icon: <FaCalendarAlt /> },
    { label: "Total Units", value: project?.projectDetails?.totalUnits || "N/A", icon: <MdApartment /> },
    { label: "Total Towers", value: project?.projectDetails?.totalTowers || "N/A", icon: <FaBuilding /> },
    { label: "BHK", value: project?.basicDetails?.bhkType || "N/A", icon: <FaCouch /> },
  ];



  return (
    <div className="max-w-5xl mx-auto p-6">
      <h2 className="text-2xl font-bold mb-2 capitalize">About {project?.basicDetails?.projectName || "Project"}</h2>
      <p className="text-gray-600">
        {project?.aboutProject ? (
          <span dangerouslySetInnerHTML={{ __html: project.aboutProject }} />
        ) : (
          "No project description available."
        )}
        <span className="text-red-500 font-medium cursor-pointer"> Read More</span>
      </p>

      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 mt-4">
        {aboutDetails.map((item, index) => (
          <div key={index} className="flex  justify-between px-4 py-2 border rounded-lg shadow-md bg-white">
            <div>
              <h4 className="text-gray-500 text-sm">{item.label}</h4>
              <p className="text-lg font-semibold whitespace-nowrap">{item.value}</p>
            </div>
            <div className="text-yellow-500 text-2xl">{item.icon}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AboutProjectSection;
